import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cx } from "../../../react-helpers/css";
import { Profile } from "../../../services/profile/profileModel";
import {
  useCountries,
  useLangs,
} from "../../../services/profile/profileService";
import { useProgressiveImage } from "../../../services/imageService";
import CandidateIcon from "../CandidateIcon";

// Pourquoi ce fichier : la carte de profil du tableau de bord candidat de la maquette v3 (vignette, nom,
// pays · langue, date de création, puce d'état) n'a plus rien à voir avec ProfileCardComponent, qui sert aussi
// aux listes des professionnels (verrouillage, archivage, favoris). La séparer évite que la refonte de l'un
// casse l'autre. Comportement repris de ProfileCard : lien vers la fiche, profil désactivé signalé.
const CandidateProfileCard = ({ profile }: { profile: Profile }) => {
  const { t } = useTranslation();
  const countries = useCountries();
  const langs = useLangs();
  const country = useMemo(
    () => countries.find((c) => c[0] === profile.country)?.[1],
    [profile.country, countries],
  );
  const language = useMemo(
    () => langs.find((c) => c[0] === profile.lang)?.[1],
    [profile.lang, langs],
  );
  const thumbnail = useProgressiveImage(
    profile.thumbnail ?? profile.thumbnailUrl,
  );
  const disabled = !!profile.disabledDate;
  const thumbStyle = {
    backgroundImage: thumbnail ? `url(${thumbnail})` : undefined,
  };

  return (
    <Link
      className={cx(["cand-pcard", disabled && "--off"])}
      to={`../profiles/${profile.id}`}
    >
      <div className="cand-pcard_thumb">
        <span className="cand-pcard_bg" style={thumbStyle} />
        <span className="cand-pcard_img" style={thumbStyle} />
        <span className="cand-pcard_play">
          <CandidateIcon name="play" />
        </span>
      </div>
      <div className="cand-pcard_body">
        <div className="cand-pcard_tx">
          <b>{profile.name}</b>
          <span>
            {country} · {language}
          </span>
          <span>
            {t("candidate:profile.card.CREATED_AT", {
              date: new Date(profile.createdAt),
            })}
          </span>
        </div>
        {disabled ? (
          <span className="ui-chip --off">
            {t("candidate:profile.card.DISABLED")}
          </span>
        ) : (
          profile.featured && (
            <span className="ui-chip --ok">
              {t("candidate:profile.card.ACTIVE")}
            </span>
          )
        )}
      </div>
    </Link>
  );
};

export default CandidateProfileCard;
